"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = require("src/components/Typography");
var theme_1 = require("src/providers/theme");
var Error = function (_a) {
    var children = _a.children;
    var theme = (0, theme_1.useTheme)();
    return react_1.default.createElement(Typography_1.Text, { color: theme.reversedColorNames[theme.palette.fieldError[0]] }, children);
};
exports.default = Error;
